var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-circle-box"},[_c('div',{staticClass:"title",style:(`margin-top:${_vm.top}rem`)},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"zIndex-1 circle-bg",attrs:{"src":require("@/assets/imgs/press-center/yuan-bg.webp"),"alt":""}})]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.title2))])])
}
var staticRenderFns = []

export { render, staticRenderFns }